/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this file will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  /*
   * Default the product purchase option to Subscription.
   *
   * On a fresh product page load (no `selling_plan` in the URL) the theme
   * renders "One-time purchase" as the selected option. To nudge customers
   * toward subscribing, we pre-select the first subscription plan once Alpine
   * has bound its handlers. The native change event triggers the theme's
   * existing @change logic, which re-renders the section (price, CTA, benefits)
   * in the subscription state. Customers can still switch back to one-time.
   *
   * This runs only on initial page load — section morphs (e.g. choosing
   * one-time afterwards) do not re-fire `alpine:initialized`, so the choice sticks.
   */
  function defaultToSubscription() {
    // Respect an explicit selling plan already present in the URL.
    if (new URL(window.location.href).searchParams.has('selling_plan')) return;

    var firstPlan = document.querySelector(
      '[data-subscription-selectors] input[name="selling_plan"]'
    );
    if (firstPlan && !firstPlan.checked) {
      firstPlan.checked = true;
      firstPlan.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  // custom.js is deferred, so Alpine may already have initialised (and fired
  // `alpine:initialized`) before this listener is attached. Handle both cases.
  if (window.Alpine) {
    defaultToSubscription();
  } else {
    document.addEventListener('alpine:initialized', defaultToSubscription);
  }

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
